"use client";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { ArticleCard } from "./articles/articlecard";

import { Button } from "./ui/button";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

const ShelveArticleBannerLoader = ({
    children,
    articles,
    priorityImage,
    loc,
    text,
    radiusStyle
}: {
    children: React.ReactNode;
    articles: Array<any>;
    pathPrefix?: string;
    priorityImage?: boolean;
    loc: string;
    text: { [key: string]: string };
    radiusStyle: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();
    const colorStyle = useContext(ColorStyleContext);

    return (
        <>
            {hasMouseMoved ? (
                <Carousel
                    opts={{
                        align: "start",
                        dragFree: true,
                    }}
                    className="w-full ">
                    <CarouselContent className={`w-full pl-4 ${articles.length < 4 && "justify-center"}`}>
                        {/* <div className="lg:px-2 md:px-5 px-2" /> */}
                        {articles.map((ac, idx) => {
                            const date = new Date(ac.publishedAt);
                            const formattedDate = date.toLocaleString(loc == "TH" ? "th-TH" : "en-GB", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            });
                            return (
                                <CarouselItem key={idx} className="xl:basis-1/4 md:basis-1/3 xs:basis-1/2">
                                    <ArticleCard article={ac} display="CARD" date={formattedDate} />
                                </CarouselItem>
                            );
                        })}
                        {/* <div className="lg:px-10 md:px-5 px-2" /> */}
                    </CarouselContent>

                    <div className="w-full flex justify-between items-center mt-10 lg:px-20 md:px-10 px-2 ">
                        <div className="w-1/3"> </div>
                        <div className="w-1/3 flex justify-center">
                            <a href="/blogs/editorial">
                                <button
                                    className="min-w-52 min-h-[48px] px-5 dynamic-bg dynamic-color text-center content-center"
                                    style={
                                        {
                                            "--dynamic-bg": colorStyle.buttonBgNormal || "#009eca",
                                            "--dynamic-hover-bg": colorStyle.buttonBgHover || "#254b7c",
                                            "--dynamic-color": colorStyle.buttonTextNormal || "#ffffff",
                                            "--dynamic-hover-color": colorStyle.buttonTextHover || "#ffffff",
                                            "--dynamic-focus-color": colorStyle.buttonTextHover || "#ffffff",
                                            borderTopLeftRadius: radiusStyle?.buttonRadiusTopLeft ?? "6px",
                                            borderTopRightRadius: radiusStyle?.buttonRadiusTopRight ?? "6px",
                                            borderBottomLeftRadius: radiusStyle?.buttonRadiusBottomLeft ?? "6px",
                                            borderBottomRightRadius: radiusStyle?.buttonRadiusBottomRight ?? "6px",
                                        } as React.CSSProperties
                                    }>
                                    {text["article_all"]}
                                </button>
                            </a>
                        </div>
                        <div className="flex w-1/3 justify-end ">
                        {
                            articles.length > 4 && (
                                <>
                                    <CarouselPrevious className="max-md:hidden relative transform  left-0 top-0 translate-y-0 mx-1 " />
                                    <CarouselNext className="max-md:hidden relative transform   left-0 top-0 translate-y-0  mx-1 " />
                                </>
                            )
                        }
                        </div>
                    </div>
                </Carousel>
            ) : (
                children
            )}
        </>
    );
};

export default ShelveArticleBannerLoader;
